"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalContactSchema = void 0;
exports.internalContactSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [],
    properties: {
        departmentName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 64,
            errorMessage: 'should have variable length up to 64 characters or null',
        },
        employeeID: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters or null',
        },
        officeAddressDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2000,
            errorMessage: 'should have variable length up to 2000 characters or null',
        },
        sectorName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 256,
            errorMessage: 'should have variable length up to 256 characters or null',
        },
        titleName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 128,
            errorMessage: 'should have variable length up to 128 characters or null',
        },
        titleTypeCode: {
            type: ['number'],
            minimum: 0,
            maximum: 9999,
            errorMessage: 'should be a number between 1-9999',
        },
        positionTitleID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
    },
};
